import uniqueId from "lodash/uniqueId";
const CHARS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function encode(value) {
    if (value === 0) {
        return "0";
    }
    let encoded = "";
    while (value > 0) {
        encoded = CHARS[value % CHARS.length] + encoded;
        value = Math.floor(value / CHARS.length);
    }
    return encoded;
}
const time = new Date().getTime();
const random = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
const prefix = `${encode(time)}-${encode(random)}`;
export default function uid() {
    return `${prefix}-${uniqueId()}`;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/uid.ts